import React, { Component } from 'react';

import './styles.css';

export default class ModalErrorData extends Component {
    constructor(props) {
        super(props)
        this.state = {
            purchaseOrderNumber: '',
            suffix: '',
            itemId: '',
            qty: '',
        }
    }

    onClose = e => {    
        this.props.onClose && this.props.onClose(e);    
    };


    render() {
        if(!this.props.show) {
            return null;
        }
        return (
            <div className="modal-background">
                <div className="errorDataModal-container">
                    <div className="errorDataModal-form">
                        <h2 className="modal-title">Error in data</h2>
                        <table className="table">
                        <thead>
                            <tr>
                            <th scope="col">PO/Item</th>
                            <th scope="col">Error</th>
                            <th scope="col">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                           {
                               this.props.data.map((data,key) => {
                                   return(
                                    <tr  key={key}>
                                        <td className="text-center">{data.keyNumber}</td>
                                        <td className="text-center">{data.code}</td>
                                        <td className="text-center">{data.message}</td>
                                    </tr>
                                   )
                               })
                           }
                        </tbody>
                        </table>
                       
                    </div>
                    <button type="button" className="btn btn-warning button-errorClose btn-sm" onClick={e => {this.onClose(e)}}>Close</button>
                </div>
            </div>
            

        );
    }

}